import { Box, Tooltip } from "@mui/material";
import { PopoverMenu } from "../../../common";
import {
  DeleteNewIcon,
  DoubleArrowsIcon,
  EditIcon,
  ReportIcon,
  SuccessIcon,
} from "../../../../assets/icons/icon";
import { useNavigate } from "react-router-dom";
import { ParagraphText } from "../../../../Libraries";
import { useAuthContext } from "../../../../context/AuthContext";
import { useContext, useState, useCallback, useMemo, memo } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Sync } from "../../../../SyncService";
import { useSnackbar } from "../../../../context/SnackbarContext";
import StockInOutModal from "../StockInOutModal";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { formateDate_dd_month_yy_lower } from "../../../../constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import imagePlaceholder from "../../../../assets/images/imagePlaceholder.png";
import styles from "./ItemRow.module.css";

const ItemRow = memo(
  ({
    visibleColumns,
    dataItem,
    data,
    rowIndex,
    actions,
    key,
    index,
    handleItemReport,
    getInitialStock,
    gridTemplateColumns,
  }) => {
    const [I18n] = useContext(LanguageContext);
    const [showStockInModal, setShowStockInModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { user } = useAuthContext();
    const { showSnackbar } = useSnackbar();
    const handleEditClick = useCallback(() => {
      triggerLogEvent(analytics, "sb_options_edit");

      navigate(`/Inventory/Edit/${dataItem.id}`);
    }, [navigate, dataItem.id]);

    const deleteItem = useCallback(
      async (e) => {
        e.stopPropagation();
        try {
          setLoading(true);
          if (dataItem) {
            await dataItem.archiveStock();
            setLoading(false);
            setShowDeleteModal(false);
            getInitialStock();
            Sync(user.phone_number, navigate);
            showSnackbar({
              message: I18n.item_deleted_successfully,
              severity: "success",
            });
            triggerLogEvent(analytics, "sb_item_deleted", {
              id: dataItem.id,
              name: dataItem.name,
            });
          }
        } catch (error) {
          setLoading(false);
        }
      },
      [dataItem, user.phone_number, showSnackbar],
    );

    const handleViewItemReport = () => {
      triggerLogEvent(analytics, "sb_options_report");

      navigate(`/Inventory/ItemReport/${dataItem.id}`);
    };

    const itemMenuOptions = useMemo(
      () => [
        {
          label: (
            <Box display={"flex"} alignItems={"center"}>
              <Box marginRight={1.8}>
                <EditIcon width={20} height={20} />
              </Box>
              <ParagraphText className="textCapitalizeFirstLetter">
                {I18n.edit_item}
              </ParagraphText>
            </Box>
          ),
          action: handleEditClick,
        },
        {
          label: (
            <Box display={"flex"} alignItems={"center"}>
              <Box marginRight={1.8}>
                <DoubleArrowsIcon width={16} height={16} />
              </Box>
              <ParagraphText>{I18n.stock_in_out}</ParagraphText>
            </Box>
          ),
          action: () => {
            setShowStockInModal(true);
            triggerLogEvent(analytics, "sb_options_in_out");
          },
        },
        {
          label: (
            <Box display={"flex"} alignItems={"center"}>
              <Box marginRight={1.8} className={styles.reportIconPopover}>
                <ReportIcon width={20} height={20} />
              </Box>
              <ParagraphText className="textCapitalizeFirstLetter">
                {I18n.view_report}
              </ParagraphText>
            </Box>
          ),
          action: () => handleViewItemReport(),
        },
        {
          label: (
            <Box display={"flex"} alignItems={"center"}>
              <Box marginRight={1.8} display={"flex"}>
                <DeleteNewIcon width={20} height={18} id="download_black_btn" />
              </Box>
              <ParagraphText className="textCapitalizeFirstLetter">
                {I18n.delete}
              </ParagraphText>
            </Box>
          ),
          action: () => {
            triggerLogEvent(analytics, "sb_options_delete");
            setShowDeleteModal(true);
          },
        },
      ],
      [handleEditClick, handleViewItemReport, I18n],
    );
    const handleClose = () => {
      setShowDeleteModal(false);
    };
    const rowData = data[rowIndex];

    const renderColumnContent = (columnId) => {
      switch (columnId) {
        case "name":
          return (
            <Box className={styles.itemColumnWrapper}>
              <Box className={styles.nameBox}>
                <Box
                  className={styles.imageBox}
                  sx={{ minWidth: "20px", justifyContent: "flex-start" }}
                >
                  <img
                    src={rowData["image_url"] ? rowData["image_url"] : imagePlaceholder}
                    alt="item_image"
                  />
                </Box>
                <ParagraphText
                  className={`fontSize14 newFontColor truncateOneLine ${styles.itemNameList}`}
                >
                  <Tooltip
                    title={
                      <ul
                        className={styles.infoToopTip}
                        style={{
                          paddingLeft: "1rem",
                          marginBottom: 0,
                        }}
                      >
                        <li>
                          <span className={"foundationInk200 fontSize12 "}>
                            {" "}
                            Item:{" "}
                          </span>
                          {rowData["name"]}
                        </li>
                        <li>
                          <span className={"foundationInk200 fontSize12 "}>
                            {" "}
                            Barcode:{" "}
                          </span>
                          {rowData["barcode"] || "-"}
                        </li>
                        <li>
                          <span className={"foundationInk200 fontSize12 "}>
                            {" "}
                            Expiry date:
                          </span>{" "}
                          {rowData["expiry_date"]
                            ? formateDate_dd_month_yy_lower(rowData["expiry_date"])
                            : "-"}
                        </li>
                      </ul>
                    }
                    arrow
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#24272F",
                          padding: "0.5rem",
                          color: "#fff",
                          fontFamily: "outfit",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#24272F",
                          fontSize: "1rem",
                        },
                      },
                    }}
                  >
                    {rowData["name"]}
                  </Tooltip>
                </ParagraphText>
              </Box>
            </Box>
          );
        case "stock":
          return (
            <Box className={styles.inputs}>
              <ParagraphText
                className={"fontSize14 textLeft newFontColor"}
                title={rowData["stock"] || "0"}
              >
                {Math.floor(rowData["stock"] * 100) / 100 || 0}
              </ParagraphText>
            </Box>
          );
        case "low_stock":
          return (
            <Box className={styles.inputs}>
              <ParagraphText
                className={"fontSize14 textLeft newFontColor"}
                title={rowData["low_stock"] || "-"}
              >
                {rowData["low_stock"] || "-"}
              </ParagraphText>
            </Box>
          );
        case "unit":
          return (
            <ParagraphText
              className={`${styles.dropdownTypo} fontSize14 newFontColor truncateOneLine`}
            >
              {rowData["unit"] || "Unit"}{" "}
              {rowData.unit && rowData.secondary_unit && (
                <span className={`${styles.unitConversionText} stockListView`}>
                  (1 {rowData.unit} = {rowData.unit_conversion} {rowData.secondary_unit})
                </span>
              )}
            </ParagraphText>
          );
        case "cost_price":
          return (
            <Box className={`${styles.inputs} ${styles.AlignRight}`}>
              <ParagraphText
                className={"fontSize14 textRight newFontColor truncateOneLine"}
                title={rowData["cost_price"] || ""}
              >
                {`${rowData["cost_price"] > 0 ? `Rs. ${formatNum(rowData["cost_price"])}` : "-"}`}
              </ParagraphText>
            </Box>
          );
        case "selling_price":
          return (
            <Box className={`${styles.inputs} ${styles.AlignRight}`}>
              <ParagraphText
                className={"fontSize14 textRight newFontColor truncateOneLine"}
                title={rowData["selling_price"] || "-"}
              >
                {`${rowData["selling_price"] > 0 ? `Rs. ${formatNum(rowData["selling_price"])}` : "-"}`}
              </ParagraphText>
            </Box>
          );
        case "barcode":
          return (
            <Box className={styles.inputs}>
              <ParagraphText
                className={"fontSize14 textLeft newFontColor truncateOneLine"}
                title={rowData["barcode"] || "--"}
              >
                {rowData["barcode"] || "--"}
              </ParagraphText>
            </Box>
          );
        case "expiry_date":
          return (
            <Box className={styles.inputs}>
              <ParagraphText
                className={"fontSize14 textLeft newFontColor truncateOneLine"}
                title={
                  rowData["expiry_date"]
                    ? formateDate_dd_month_yy_lower(rowData["expiry_date"])
                    : "--"
                }
              >
                {rowData["expiry_date"]
                  ? formateDate_dd_month_yy_lower(rowData["expiry_date"])
                  : "--"}
              </ParagraphText>
            </Box>
          );
        case "batch_number":
          return (
            <Box className={styles.inputs}>
              <ParagraphText
                className={"fontSize14 textLeft newFontColor truncateOneLine"}
                title={rowData["batch_number"] || ""}
              >
                {rowData["batch_number"] || ""}
              </ParagraphText>
            </Box>
          );
        case "wholesale_price":
          return (
            <Box className={`${styles.inputs} ${styles.AlignRight}`}>
              <ParagraphText
                className={"fontSize14 textRight newFontColor truncateOneLine"}
                title={rowData["wholesale_price"] || ""}
              >
                {`${rowData["wholesale_price"] > 0 ? `Rs. ${formatNum(rowData["wholesale_price"])}` : "-"}`}
              </ParagraphText>
            </Box>
          );
        case "manufacturing_date":
          return (
            <Box className={styles.inputs}>
              <ParagraphText
                className={"fontSize14 textLeft newFontColor truncateOneLine"}
                title={
                  rowData["manufacturing_date"]
                    ? formateDate_dd_month_yy_lower(rowData["manufacturing_date"])
                    : "--"
                }
              >
                {rowData["manufacturing_date"]
                  ? formateDate_dd_month_yy_lower(rowData["manufacturing_date"])
                  : "--"}
              </ParagraphText>
            </Box>
          );
        default:
          return null;
      }
    };
    return (
      <Box
        id={`stockItem_${index}`}
        key={key}
        className={`cursorPointer ${styles.stockItemRow}`}
        sx={{
          width: "100%",
          minWidth: 0,
          display: "grid",
          gridTemplateColumns,
          boxSizing: "border-box",
          "& > .MuiBox-root": {
            minWidth: 0,
            boxSizing: "border-box",
          },
        }}
        onClick={() => {
          if (showDeleteModal || showStockInModal) return;
          triggerLogEvent(analytics, "sb_list_item_click", {
            item_id: dataItem?.id,
            item_name: dataItem?.name,
          });
          handleItemReport(dataItem);
        }}
      >
        {visibleColumns.map((columnId) => (
          <Box
            key={columnId}
            className={`${styles.boxWrapper} ${
              columnId === "unit" ? styles.dropdown : ""
            }`}
          >
            {renderColumnContent(columnId)}
          </Box>
        ))}

        {actions && (
          <Box
            display="flex"
            className={styles.fixedActionsColumn}
          >
            <div className="tblOptnBox" role="button">
              <PopoverMenu
                menuOptions={itemMenuOptions}
                popOverStyle={{
                  marginLeft: "5px",
                  borderRadius: "16px !important",
                }}
                // buttonStyle={{
                //   backgroundColor: "var(--foundationGrey)",
                //   width: "32px",
                //   height: "36px",
                //   borderRadius: "50%",
                // }}
                id="stock_item_row_menu"
              />
            </div>
          </Box>
        )}

        {showDeleteModal && (
          <ConfirmationModal
            id="stock_del_modal"
            open={showDeleteModal}
            onConfirm={deleteItem}
            onClose={handleClose}
            title={I18n.this_action_cannot_be_undone}
            message={I18n.are_you_sure_you_want_to_delete_item}
            confirmText={I18n.delete}
          />
        )}

        {showStockInModal && (
          <StockInOutModal
            showStockInModal={showStockInModal}
            setShowStockInModal={setShowStockInModal}
            item={data[rowIndex]}
          />
        )}
      </Box>
    );
  },
);

export default ItemRow;
